var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramInterest40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 24 0 0 13.4626039 0 18.9473684 5.5 18.9473684 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "5.38488854 5.67320727 2.12832847e-14 5.67320727 2.12832847e-14 0.218661818"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interest40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(11.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-2.49307479 -2.5 21.4404432 -2.5 21.4404432 26.5 -2.49307479 26.5"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-4",
    stroke: "#4F4C4D",
    points: "0 24 0 0 13.4626039 0 18.9473684 5.5 18.9473684 24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(13.374613, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-6",
    fill: "#FFCC00",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-8",
    stroke: "#4F4C4D",
    points: "18.9473684 5.45454545 13.374613 5.45454545 13.374613 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.464466, 17.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#4F4C4D",
    strokeWidth: 0.75,
    cx: 1.78553391,
    cy: 1.75,
    r: 1.375
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#4F4C4D",
    strokeWidth: 0.75,
    cx: 5.78553391,
    cy: 6.75,
    r: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4F4C4D",
    transform: "translate(3.535534, 4.500000) rotate(-45.000000) translate(-3.535534, -4.500000) ",
    x: -0.964466094,
    y: 4,
    width: 9,
    height: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramInterest40);
export default __webpack_public_path__ + "static/media/pictogramInterest40.d2a87282e6f6829cade747fcba252c02.svg";
export { ForwardRef as ReactComponent };